export const setTimeoutRAF = (callback, delay) => {
  const start = performance.now();

  function loop(currentTime) {
    const elapsed = currentTime - start;
    if (elapsed >= delay) {
      callback();
    } else {
      requestAnimationFrame(loop);
    }
  }

  requestAnimationFrame(loop);
};
